(ns practitest.frontend.forms3.entity-form.utils 
  (:require
   [practitest.frontend.common.mixpanel :as mixpanel]))

(defn track! [action entity-type]
  (mixpanel/track "Form Actions" {"Entity" (mixpanel/entity-type->mixpanel entity-type)
                                 "Action" action}))

(def get-modal-title
  (fn [action to-entity entity-id entity-name]
    (str action
         " "
         to-entity
         " #"entity-id " - " entity-name)))